import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, generatePath, useLocation, useParams } from "react-router-dom";

import { Box } from "@chakra-ui/react";

import BackToTripButton from "components/Journey/BackToTripButton";
import FunnelLayout from "components/Layouts/FunnelLayout";
import { PAGE_PATHS } from "config/routes";
import { SessionContext } from "contexts";
import { AirBundleFunnel } from "funnels/AirBundleFunnel";

type Params = {
  id: string;
};

const AirBundlePage = ({ isAirLuggage }: { isAirLuggage?: boolean }) => {
  const { user } = useContext(SessionContext);
  const { t } = useTranslation();
  const { id } = useParams<Params>();

  const { pathname } = useLocation();

  if (!id || !user) {
    return <Navigate to={{ pathname: generatePath(PAGE_PATHS.HOME_PAGE) }} />;
  }

  const airLuggageConfirmationPage = generatePath(PAGE_PATHS.JOURNEY.AIR_LUGGAGE.PAYOUT_CONFIRMATION_PAGE, {
    id: id.toString(),
  });

  const airPayoutConfirmationPage = generatePath(PAGE_PATHS.JOURNEY.AIR_PAYOUT.PAYOUT_CONFIRMATION_PAGE, {
    id: id.toString(),
  });

  const disableAssistantBadge = airPayoutConfirmationPage === pathname || airLuggageConfirmationPage === pathname;

  const steps = [
    t("common.eligibility_check"),
    isAirLuggage ? t("air_luggage.luggage_details.luggage_details") : t("common.documents"),
    t("instant_cash.payout.bank_details"),
    t("common.payment_confirmation"),
  ];

  return (
    <FunnelLayout
      disableAssistantBadge={disableAssistantBadge}
      disableCurrencySwitcher
      steps={steps}
      sideHeader={
        <Box mb={10}>
          <BackToTripButton dataTestId="back-to-journey-desktop-button" />
        </Box>
      }
      headerStart={
        <Box mt={{ base: 1, sm: 2 }} mr={4}>
          <BackToTripButton variantBreakpoint="xl" dataTestId="back-to-journey-mobile-button" />
        </Box>
      }
    >
      <AirBundleFunnel journeyId={id} isAirLuggage={isAirLuggage} />
    </FunnelLayout>
  );
};

export default AirBundlePage;
